import { Badge, Group, Paper, Text, Tooltip } from "@mantine/core";
import { Handle, type Node, type NodeProps, Position } from "@xyflow/react";
import { type ExplodeNodeData, NodeRole } from "./types";

const ROLE_STYLE = {
    [NodeRole.ROOT]: { bg: "purple.7", fg: "white", border: "#5f3dc4" },
    [NodeRole.GROUP]: { bg: "white", fg: undefined, border: "#5f3dc4" },
};

const hiddenHandle = { opacity: 0 };

export const BucketNode = ({ data }: NodeProps<Node<ExplodeNodeData>>) => {
    const style = ROLE_STYLE[data.role];
    const isRoot = data.role === NodeRole.ROOT;
    return (
        <Paper
            withBorder
            p="md"
            radius="md"
            bg={data.focused ? "violet.0" : style.bg}
            style={{
                width: 200,
                borderColor: data.focused ? "#5f3dc4" : style.border,
                borderWidth: data.focused ? 3 : 2,
                cursor: isRoot ? "default" : "pointer",
                opacity: data.dimmed ? 0.1 : 1,
                pointerEvents: data.dimmed ? "none" : "auto",
                transition: "opacity 350ms ease, border-color 250ms ease",
            }}
        >
            <Handle type="target" position={Position.Top} style={hiddenHandle} />
            <Group justify="space-between" gap="sm" wrap="nowrap" align="center">
                <Tooltip label={data.label} withArrow multiline maw={260} openDelay={250}>
                    <Text
                        size="md"
                        fw={700}
                        lineClamp={2}
                        c={style.fg}
                        style={{ flex: 1, minWidth: 0 }}
                    >
                        {data.label}
                    </Text>
                </Tooltip>
                {data.count !== undefined && (
                    <Badge
                        size="lg"
                        variant={isRoot ? "white" : "filled"}
                        color="purple"
                        style={{ flexShrink: 0 }}
                        styles={{ label: { overflow: "visible" } }}
                    >
                        {data.count.toLocaleString()}
                    </Badge>
                )}
            </Group>
            <Handle type="source" position={Position.Bottom} style={hiddenHandle} />
        </Paper>
    );
};
